import React from 'react';
import { Box, Container, Heading } from '@hover/blueprint';
import { CustomerQuote } from '../../common';
import { ICustomerQuote } from '../../../interfaces/ICustomerQuote';

interface Props extends ICustomerQuote {}

const DesktopSlide: React.FC<Props> = ({
  image,
  header,
  logo,
  id,
  role,
  name,
  quote,
  ...rest
}) => (
  <Box
    display="flex !important"
    alignItems="center"
    justifyContent="space-between"
    w="100%"
    role="group"
    aria-label={`Slide ${id} of 2`}
    {...rest}
  >
    <Container
      ml={0}
      flexDir="column"
      alignItems="flex-start"
      maxW="730px"
      px={200}
    >
      <Heading size={700} marginBottom={900} as="h2">
        {header}
      </Heading>
      <CustomerQuote
        name={name}
        customerRole={role}
        description={quote}
        logo={logo}
      />
    </Container>
    <Box pr={400}>{image}</Box>
  </Box>
);

export default DesktopSlide;
